import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IUnrestrictedInternalTransferData } from '../../types/accounting/data/IUnrestrictedInternalTransferData';
import { eInternalTransferCategory } from '../../types/accounting/response/eInternalTransferCategory';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export interface ICreateExpectedInternalTransferRequest {
  amountCents: number;
  category: eInternalTransferCategory;
  note: string;
  escrowFileId: string;
  sourceAccountId: string;
  destinationAccountId: string;
  unrestricted: boolean;
}

export const createExpectedInternalTransferAsync = async (
  params: ICreateExpectedInternalTransferRequest
): Promise<IUnrestrictedInternalTransferData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<IUnrestrictedInternalTransferData>(`/timber/api/internal/escrow/expected_internal_transfers`, params)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
